import { Box, Checkbox, FormControlLabel, Modal } from "@mui/material"
import { useEffect, useState } from "react"
import { Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import { Context, TenantInformation } from "../../../../types/types";
import { del } from "../../../../util/Axios";

export interface DeleteTenantModalProps {
    selectedRows: TenantInformation[],
    open: boolean,
    cancel: Function,
    context: Context,
    onSuccess: Function,
}


function TenantDemoDeleteModal(props: DeleteTenantModalProps) {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        minHeight: '20%',
        maxHeight: '75%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        overflow: 'hidden',
        p: 4,
    };

    const deleteTenants = async (forceDelete: boolean) => {
        for (let i = 0; i < props.selectedRows.length; i++) {
            const tenant = props.selectedRows[i]
            const tenantId = tenant['id']
            const params = `tenantId=${tenantId}&delDb=true&delDNS=true&delSecrets=true&forceDel=false`
            let response: any = await del(`/contexts/${props.context.id}/crud/mandantendelete?${params}`).catch(error => {
                return toast.error(`Error deleting Tenant - ${error.response.status}: ${error.response.data}`)
            })
            if (response.status !== 200) {
                toast.error(`Could not delete Azure ressources of Tenant with ID ${tenantId}: Code ${response.status}. Keeping Tenant`)
                continue
            }
            toast.success(`Deletion for Tenant ${tenant['shortname']} started`)
        }
        props.onSuccess()
      }

    return (
        <Modal
            open={props.open}
            onClose={() => {props.cancel()}}
        >
            <Box sx={style}>
                <span>Do you really want to delete the following tenants?</span>
                <div style={{display: "flex", flexDirection: "column", paddingBottom: '5px'}}>
                    {props.selectedRows.map(row => {
                        return (
                            <span>- {row.shortname}</span>
                        )
                    })}
                </div>
                <div style={{display: 'flex', gap: '10px'}}>
                    <Button variant="secondary" onClick={() => props.cancel()}>Cancel</Button>
                    <Button onClick={() => deleteTenants(false)}>Delete</Button>
                </div>
            </Box>
        </Modal>
    )
}

export default TenantDemoDeleteModal